import { createApp } from 'vue'
import App from '@/page/vue/2024/index.vue'
import '@/styles/index.scss'
import tongji from '@/utils/tongji.js'; //引入统计
import initShare from '@/utils/wxShare.js'
import Antd from 'ant-design-vue'
import Vant from 'vant'
import 'ant-design-vue/dist/antd.css'
import 'animate.css'
import '@/styles/index.scss'
import 'vant/lib/index.css'

import Qapm from '@q/qapm';
Qapm('init', {
    appKey: 'isc',
    env: import.meta.env.MODE,
    ratio: 100,
});

tongji()
initShare({
  title: 'ISC.AI 2024第十二届互联网安全大会专题页',
  desc: '7.31-8.1北京国家会议中心，邀您一起助力数字安全革新，共探AI技术与行业融合新境界，激发生产力新动能！',
  imgUrl: 'https://p3.ssl.qhimg.com/t110b9a9301b692d1d162b7c790.jpg',
  link: window.location.href
})


const app = createApp(App)
app.use(Antd)
app.use(Vant)
app.mount('#app')







